import { environment } from '@quartz-gov-legacy/environments/environment';
﻿
(function () {
    'use strict';

    angular
        .module('itemTaskModule')
        .factory('itemTaskService', service);

    service.$inject = ['$http'];

    function service($http) {

        var baseUrl = environment.apiUrl + '/Pilot/api/ItemTask';
        var returnData = function (response) { return response.data; };

        return {

            // Get Item Task By Name
            getItemTaskByNameForUser: function (taskDefinitionName) {
                return $http
                    .get(baseUrl + '/ByName/' + taskDefinitionName)
                    .then(returnData);
            },

            // Complete Item Task
            completeItemTaskByNameForUser: function (taskDefinitionName) {
                return $http
                    .post(baseUrl + '/ByName/' + taskDefinitionName)
                    .then(returnData);
            }
        };
    }
})();
